import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import ApiHandler from "./../../../services/api/ApiHandler";
import apiPayload from './../../../services/api/ApiPayload';
import localStorageService from './../../../helpers/store/StorageService';
import CloudLoader from './../loader/Loader_02';

export default function GettingStarted({ contentData, initError, initLoader }) {
  let { data, loading, error, handlePostApi } = ApiHandler();

  useEffect(() => {
    // Prevent repeat calls with a mounted check
    let isMounted = true;
    if (isMounted) {
      apiPayload.set('load.pageId', 'Page30002');
      apiPayload.set('load.redirectRoute', '/getting-started');
      apiPayload.set('load.data.userId', localStorageService.get('active', -1, 'int'));
      handlePostApi("/v1/start", apiPayload.fetchPayload());
    }

    // Cleanup to prevent updates after unmount
    return () => {
      isMounted = false;
    };
    // TODO : Clear the warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let isOk = (data ? (data.code === "200" ? true : false) : false);
  let isAuth = localStorageService.get('report', false, 'boolean');

  return (
    <>
      {isOk && (<div>
        {!isAuth && data && (<div className="grid-container">
          <div className="rewards-showcase">
            <div className="reward-item">
              <span className="members-indicator">Active Users&nbsp;
                <span className="green-led"></span>
                &nbsp; { data.result.api_request_data.n_members }
              </span>
            </div>
          </div>
        </div>)}

        {isAuth && (<div>
          <div className="static-content">
            <div className="content-section">
              <div className="content-body">
                <p className="content-paragraph">Your BTC Balance</p>
              </div>
              <h3 className="section-title">{ data.result.api_request_data.btc_balance }</h3>
            </div>
          </div>
          <br/>
          <div className="grid-container-2">
            <Link to='/auth/user/receive' className="grid-item-special nav-item-special">Receive BTC</Link>
            <Link to='/auth/user/send' className="grid-item-special nav-item-special">Send BTC</Link>
          </div>
        </div>)}
        
        <div className="grid-container">
          {data.result.api_request_data.nav_app.map((navApp, index) => (
            <Link key={index} to={navApp.to} className="grid-item-styled nav-item-styled">{navApp.title}</Link>
          ))}
        </div>
        <hr style={{border:'none', height:'2px', background:'linear-gradient(to right, #e600c7 0%, #940180 25%, rgb(0, 0, 0) 100%)', boxShadow: 'rgba(0, 0, 0, 0.5) 0px 1px 3px inset', margin:'20px 0px', width:'100%'}} />
        <div className="grid-container">
          {data.result.api_request_data.nav_community_legal.map((navCommunityLegal, index) => (
            <Link key={index} to={navCommunityLegal.to} className="grid-item nav-item">{navCommunityLegal.title}</Link>
          ))}
        </div>
      </div>)}
      {initLoader && <CloudLoader />}
      {initError && <p style={{ color: "red" }}>App Error - {initError.message}</p>}
      {loading && <CloudLoader />}
      {error && <p style={{ color: "red" }}>Getting Started Error - {error.message}</p>}
    </>
  );
}
